/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * ``POST /inbox/chats/bulk-mark`` body — LinkedIn mirror of
 * :class:`BulkMarkThreadsRequest`.
 */
export interface BulkMarkChatsRequest {
  /**
     * @minItems 1
     * @maxItems 50
     */
  chat_ids: string[];
  read: boolean;
}
